module.exports = __webpack_public_path__ + "static/media/play.da83da7e.svg";